module.exports = "/_next/static/images/turkish_airlines-e8059a64440b9ac315fc0338397d6d64.svg";